// extracted by mini-css-extract-plugin
export var dropdown = "_u2-0";
export var imageWrapper = "_u2-3";
export var itemNameContainer = "_u2-1";
export var productImage = "_u2-2";
export var spinnerWrapper = "_u2-4";